import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { IndustryCatalogType, PageResponse, Pagination } from '@core/shared/domain';
import { getProp } from '@core/shared/util';
import { FlyoutIndustryCatalog, PlattformkatalogeService } from '@mp/content-manager/plattformkataloge/data-access';

type QuerierParams = {
  searchTerm: string;
  catalogType: Array<IndustryCatalogType>;
  excludeIds?: Array<string>;
};

export class KatalogeQuerier {
  private readonly _totalKatalogeCount$ = new BehaviorSubject(-1);
  readonly totalKatalogeCount$ = this._totalKatalogeCount$.asObservable();

  constructor(
    private readonly service: PlattformkatalogeService,
    private readonly params: { forId?: string; excludeIds?: Array<string> },
  ) {}

  getPage(pagination: Pagination, filters: QuerierParams): Observable<PageResponse<FlyoutIndustryCatalog>> {
    if (this.params.forId === undefined) {
      // createMode

      const filter = {
        searchTerm: filters.searchTerm,
        catalogType: filters.catalogType,
        excludeIds: this.params.excludeIds,
      };

      return this.service.getAllIndustriekatalogeInCreateFlyout(filter, pagination);
    } else {
      return this.service.getUnassignedIndustriekatalogeForPlattformkatalog(this.params.forId, filters, pagination);
    }
  }

  getAllKataloge(filters?: QuerierParams): Observable<Array<FlyoutIndustryCatalog>> {
    const filter = {
      searchTerm: filters?.searchTerm,
      catalogType: filters?.catalogType,
      excludeIds: this.params.excludeIds,
    };

    return this.service.getUnassignedIndustriekatalogePerSelectAllButton(this.params.forId!, filter).pipe(
      tap(({ pagination }) => this._totalKatalogeCount$.next(pagination.totalRowCount)),
      getProp('data'),
    );
  }
}
